import { type Dispatch } from "@reduxjs/toolkit";
import DataService from "../../../../../Application/services/dataServices/typedDataService";
import { setFilterOptions, setIsLoading } from "../slices/groupMembersFiltersSlice";
import type { AxiosResponse } from "axios";
import { setError } from "features/Application/slices/appErrorSlice";

const mapData = (data: AxiosResponse<string[]>) =>
  data.data.filter((x: string) => x !== "" && x !== null).map((x: string) => ({ text: x, value: x }));

export const fetchGroupUsersOptions = () => async (dispatch: Dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const departments = await DataService.users.getDepartments();
    const jobTitles = await DataService.users.getJobTitles();

    dispatch(
      setFilterOptions({
        departments: mapData(departments),
        jobTitles: mapData(jobTitles),
      }),
    );
  } catch (e) {
    dispatch(setError(e));
    dispatch(setIsLoading(false));
  }
};
